import { render } from "./document-list-header.vue?vue&type=template&id=62182b14&ts=true"
import script from "./document-list-header.ts?vue&type=script&lang=ts"
export * from "./document-list-header.ts?vue&type=script&lang=ts"

import "./document-list-header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__